export const getters = {
    isAuthenticated(state) {
        return state.authenticated;
    },
    getUser(state) {
        // Directly return the user object from reactive state
        return state.user;
    },
    getName(state) {
        const user = state.user?.data;
        return user ? [user.first_name, user.last_name].filter(Boolean).join(' ') : '';
    },
    getEmail(state) {
        return state.user?.data?.email ?? '';
    },
    /**
     * The Deenly team (any role but the app's own) goes to the panel; everyone
     * else to the Academy. Sessions saved before roles came with the account
     * could only be the team's: nobody else could sign in then.
     */
    isTeam(state) {
        const roles = state.user?.data?.roles;
        if (!state.authenticated) return false;
        return roles === undefined || roles.some((role) => role !== 'app-user');
    },
    isAdmin(state) {
        const roles = state.user?.data?.roles;
        return roles === undefined || roles.some((role) => role === 'super-admin' || role === 'admin');
    },
    isSuperAdmin(state) {
        return (state.user?.data?.roles ?? []).includes('super-admin');
    },
    /** Where "home" is for the signed-in person. */
    homeRoute() {
        return this.isTeam ? '/dashboard' : '/akademija';
    },
    getProfilePhoto(state) {
        return state.user ? state.user?.data?.profile_photo ?? '' : '';
    },
};
